<template>
  <q-dialog v-model="showModal" @hide="onHide" :no-esc-dismiss="true" @escape-key="onDialogEscapeKey">
    <q-layout view="Lhh lpR fff" container class="bg-white modal-large" style="height: 90vh; max-height: 90vh;">
      <q-header class="modal-header-fixed">
        <q-linear-progress :value="1" class="bg-primary" />
        <q-toolbar class="bg-primary text-white">
          <q-toolbar-title class="text-h6">
            <translate v-if="this.mode === 'edit'">EDIT_TEMPLATE</translate>
            <translate v-if="this.mode === 'create'">CREATE_TEMPLATE</translate>
          </q-toolbar-title>
          <q-btn flat round dense icon="close" @click="onCloseButtonClick" />
        </q-toolbar>
      </q-header>

      <q-form ref="templateForm" @submit.prevent="onSave">
        <q-page-container class="template-page" style="padding: 16px 16px 16px 16px !important;">
          <div class="template-container row q-col-gutter-md">
            <div class="template-col-left col-12 col-md-6">
              <q-card flat class="q-mb">
                <q-card-section class="q-py-sm q-card__section q-card__section--vert">
                  <div class="crud-title row items-center justify-between">
                    <span>{{ this.$gettext('TEMPLATE') }}</span>
                    <div class="row items-center no-wrap q-gutter-sm">
                      <span class="text-caption text-grey-7">{{ this.$gettext('TEMPLATE_ACTIVE') }}</span>
                      <q-toggle v-model="formData.available" />
                    </div>
                  </div>
                </q-card-section>

                <q-card-section class="section-body">
                  <div class="row q-col-gutter-md">
                    <div class="col-12">
                      <q-input
                        ref="inputTemplateName"
                        v-model="formData.name"
                        outlined
                        :label="this.$gettext('TEMPLATE_NAME_REQUIRED')"
                        :rules="[val => !!val || this.$gettext('TEMPLATE_REQUIRED_FIELD')]"
                      />
                    </div>
                    <div class="col-12 col-md-12">
                      <q-select
                        ref="inputTemplateChannel"
                        v-model="formData.channelType"
                        outlined
                        :label="this.$gettext('SEND_CHANNEL') + ' *'"
                        :options="channelOptions"
                        option-value="value"
                        option-label="label"
                        emit-value
                        map-options
                        :rules="[val => !!val || this.$gettext('TEMPLATE_REQUIRED_FIELD')]"
                      >
                        <template v-slot:prepend>

                            <q-icon
                              :style="{ color: getChannelColor(formData.channelType) + ' !important' }"
                              :name="getChannelIcon(formData.channelType)"
                            />

                        </template>
                        <template v-slot:option="scope">
                          <q-item
                            v-bind="scope.itemProps"
                            v-on="scope.itemEvents"
                          >
                            <q-item-section avatar>

                                <q-icon
                                  :style="{ color: getChannelColor(scope.opt.value) + ' !important' }"
                                  :name="getChannelIcon(scope.opt.value)"
                                />

                            </q-item-section>
                            <q-item-section>
                              <q-item-label>{{ scope.opt.label }}</q-item-label>
                            </q-item-section>
                          </q-item>
                        </template>
                      </q-select>
                    </div>
                  </div>
                </q-card-section>
              </q-card>

              <q-card flat class="q-mb">
                <q-card-section class="q-py-sm q-card__section q-card__section--vert">
                  <div class="crud-title">
                    <div>
                      <span>{{ this.$gettext('TEMPLATE_PURPOSE') }} *</span>
                      <div class="text-caption text-grey-6">{{ this.$gettext('TEMPLATE_COMMUNICATION_TYPE') }}</div>
                    </div>
                  </div>
                </q-card-section>

                <q-card-section class="section-body">
                  <q-field
                    ref="inputTemplatePurpose"
                    borderless
                    :model-value="formData.messagingPurpose"
                    :rules="[val => (val !== null && val !== undefined && val !== '') || this.$gettext('TEMPLATE_REQUIRED_FIELD')]"
                  >
                    <template v-slot:control>
                      <div class="purpose-grid" :class="{ 'purpose-grid--error': purposeValidationError }">
                        <div
                          v-for="option in purposeCards"
                          :key="option.id"
                          class="purpose-item"
                          :class="{ 'is-selected': formData.messagingPurpose === option.id }"
                          @click="selectPurpose(option.id)"
                        >
                          <div class="purpose-check" v-if="formData.messagingPurpose === option.id">
                            <q-icon name="check_circle" size="18px" />
                          </div>
                          <div class="purpose-icon">
                            <q-icon :name="option.icon" size="32px" :color="formData.messagingPurpose === option.id ? '#1e88e5' : 'primary'" />
                          </div>
                          <div class="purpose-title">{{ option.title }}</div>
                          <div class="purpose-desc">{{ option.description }}</div>
                        </div>
                      </div>
                    </template>
                  </q-field>
                </q-card-section>

              </q-card>

              <q-card flat class="q-mb">
                <q-card-section class="q-py-sm q-card__section q-card__section--vert">
                  <div class="crud-title">
                    <span>Conteúdo</span>
                  </div>
                </q-card-section>

                <q-card-section class="section-body">
                  <div class="subject-editor-wrapper q-mb-md" :class="{ 'subject-editor-wrapper--error': subjectValidationError }">
                    <subject-editor
                      ref="subjectEditor"
                      :label="this.$gettext('SUBJECT') + ' *'"
                      :content="formData.subject"
                      :mention-items="availableMentionItems"
                      :message-variables="availableMessageVariables"
                      @update:content="onSubjectUpdate"
                    />
                  </div>
                  <div v-if="subjectValidationError" class="text-red text-caption q-mb-md">
                    {{ this.$gettext('MSG_SUBJECT_REQUIRED') }}
                  </div>

                  <div class="text-subtitle2 q-mb-md">{{ this.$gettext('MESSAGE_BODY') }}</div>
                  <div class="template-body-wrapper" :class="{ 'template-body-wrapper--error': contentValidationError }">
                    <template-editor
                      ref="templateEditor"
                      :content="formData.content"
                      :mention-items="availableMentionItems"
                      :message-variables="availableMessageVariables"
                      :allow-formatting="!isSmsChannel"
                      @update:content="onContentUpdate"
                    />
                  </div>
                  <q-field
                    ref="inputTemplateContent"
                    class="hidden-content-validation"
                    borderless
                    hide-bottom-space
                    :model-value="hasBodyContent() ? 'valid' : ''"
                    :rules="[val => !!val || this.$gettext('MSG_TEMPLATE_BODY_REQUIRED')]"
                  />
                </q-card-section>
                <q-card-section v-if="contentValidationError" class="text-red text-caption q-pa-sm">
                  {{ this.$gettext('MSG_TEMPLATE_BODY_REQUIRED') }}
                </q-card-section>

                <q-card-section v-if="hasPurposeSelected && filteredMessageVariables.length > 0">
                  <div class="variables-by-category">
                    <div v-for="category in filteredMessageVariables" :key="category.variableType" class="variable-category q-mb-md">
                      <div class="category-title q-mb-sm">
                        <span
                          class="category-dot"
                          :class="getVariableColorScheme(category.variableType).colorClass"
                        ></span>
                        {{ category.nmDescricao }}
                      </div>
                      <div class="variables-container">
                        <span
                          v-for="variable in category.variables"
                          :key="variable.technicalKey"
                          class="editor-variable-chip"
                          :class="getVariableColorScheme(variable).colorClass"
                          style="cursor:pointer; margin:2px 4px 2px 0;"
                          @click="insertVariablePlaceholder(variable)"
                        >
                          {{ variable.displayLabel }}
                        </span>
                      </div>
                    </div>
                  </div>
                </q-card-section>
              </q-card>
            </div>

            <div class="template-col-right col-12 col-md-6">
              <template-preview-panel
                :purpose-label="selectedPurposeLabel"
                :channel-label="selectedChannelLabel"
                :channel-type="formData.channelType"
                :subject="formData.subject"
                :body-html="getPreviewContent()"
                :message-variables="availableMessageVariables"
                :header-image="headerImagePreview"
                :footer-image="footerImagePreview"
                :show-controls="!isSmsChannel"
                @header-click="onHeaderClick"
                @footer-click="onFooterClick"
                @remove-header="removeHeaderImage"
                @remove-footer="removeFooterImage"
              />
            </div>
          </div>
        </q-page-container>

        <q-footer class="template-footer modal-footer-fixed q-pa-md">
          <div class="row justify-center q-gutter-x-md">
            <q-btn
              :label="cancelLabel"
              color="primary"
              @click="onCancel"
              class="q-px-xl"
            />
            <q-btn
              :label="this.$gettext('SAVE')"
              color="green"
              @click="onSave"
              class="q-px-xl"
            />
          </div>
        </q-footer>
      </q-form>
    </q-layout>
    <input
      ref="headerInput"
      type="file"
      accept="image/*"
      style="display: none"
      @change="onHeaderFileChange"
    />
    <input
      ref="footerInput"
      type="file"
      accept="image/*"
      style="display: none"
      @change="onFooterFileChange"
    />
  </q-dialog>
</template>

<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import { messageBox, repository } from 'jtech'
import TemplatePreviewPanel from './TemplatePreviewPanel.vue'
import TemplateEditor from './TemplateEditor.vue'
import SubjectEditor from './SubjectEditor.vue'
import { templateImageType } from 'src/shared/inf-tabela-descricao/TemplateImageType.enum.js'
import { variableType } from 'src/shared/inf-tabela-descricao/VariableType.enum.js'
import { getChannelColor, getChannelIcon } from '../utils/channelMappings.js'

@Component({
  name: 'TemplateModal',
  components: {
    TemplatePreviewPanel,
    TemplateEditor,
    SubjectEditor
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    getPurposeIcon: {
      type: Function,
      required: true
    },
    getVariableColorScheme: {
      type: Function,
      required: true
    },
    purposeTypes: {
      type: Object,
      required: true
    }
  }
})
class TemplateModal extends Vue {
  get HEADER_IMAGE_TYPE () {
    return templateImageType().HEADER.key
  }

  get FOOTER_IMAGE_TYPE () {
    return templateImageType().FOOTER.key
  }

  getChannelIcon (channelId) {
    return getChannelIcon(channelId)
  }

  getChannelColor (channelId) {
    return getChannelColor(channelId)
  }

  showModal = false
  mode = 'create'
  currentId = null

  formData = {
    name: '',
    messagingPurpose: null,
    channelType: null,
    subject: '',
    content: '',
    available: true
  }

  originalFormData = {
    name: '',
    messagingPurpose: null,
    channelType: null,
    subject: '',
    content: '',
    available: true
  }

  originalHeaderImagePreview = null
  originalFooterImagePreview = null

  existingImages = []
  purposeOptions = []
  channelOptions = []
  messageVariables = []
  headerImageFile = null
  footerImageFile = null
  headerImagePreview = null
  footerImagePreview = null
  purposeValidationError = false
  subjectValidationError = false
  contentValidationError = false

  mounted () {
    this.showModal = this.show
    this.loadCombos()
  }

  get cancelLabel () {
    return this.$gettext('CANCEL')
  }

  get isSmsChannel () {
    // SMS channel ID is 50460002
    return String(this.formData.channelType || '') === String(50460002) || this.formData.channelType === 50460002
  }

  get purposeDescription () {
    const purposeId = this.formData.messagingPurpose
    const descriptions = {
      [this.purposeTypes.ONE_TIME_PAYMENT]: this.$gettext('PURPOSE_ONE_TIME_PAYMENT'),
      [this.purposeTypes.INSTALLMENT]: this.$gettext('PURPOSE_PAYMENT_INSTALLMENT'),
      [this.purposeTypes.REGULAR_INVOICE]: this.$gettext('PURPOSE_REGULAR_INVOICE'),
      [this.purposeTypes.NOTICE]: this.$gettext('PURPOSE_NOTICE'),
      [this.purposeTypes.ADDITIONAL]: this.$gettext('PURPOSE_ADDITIONAL')
    }
    return descriptions[purposeId] || ''
  }

  get helpDescription () {
    const descriptions = []

    if (this.purposeDescription) {
      descriptions.push(this.purposeDescription)
    }

    return descriptions.join(' • ')
  }

  get selectedPurposeLabel () {
    const selected = this.purposeCards.find(p => p.id === this.formData.messagingPurpose)
    return selected ? selected.title : ''
  }

  get selectedChannelLabel () {
    const selected = this.channelOptions.find(c => c.value === this.formData.channelType)
    return selected ? selected.label : ''
  }

  get filteredMessageVariables () {
    if (!this.formData.messagingPurpose) {
      return this.messageVariables
    }
    // Filtra variáveis que possuem o propósito selecionado
    return this.messageVariables
      .map(category => ({
        ...category,
        variables: Array.isArray(category.variables)
          ? category.variables.filter(
            v => Array.isArray(v.messagingPurposes)
              ? v.messagingPurposes.includes(this.formData.messagingPurpose)
              : true
          )
          : []
      }))
      .filter(category => category.variables.length > 0)
  }

  get hasPurposeSelected () {
    return this.formData.messagingPurpose !== null && this.formData.messagingPurpose !== undefined && this.formData.messagingPurpose !== ''
  }

  get availableMessageVariables () {
    return this.hasPurposeSelected ? this.filteredMessageVariables : []
  }

  get mentionItems () {
    const categories = Array.isArray(this.filteredMessageVariables) ? this.filteredMessageVariables : []
    return categories.flatMap(category => {
      const categoryLabel = category.nmDescricao || ''
      const variables = Array.isArray(category.variables) ? category.variables : []
      return variables.map(variable => {
        const colorScheme = this.getVariableColorScheme(variable)
        return {
          id: variable.technicalKey,
          label: variable.displayLabel,
          technicalKey: variable.technicalKey,
          variableType: variable.variableType,
          categoryLabel,
          colorClass: colorScheme.colorClass
        }
      })
    })
  }

  get availableMentionItems () {
    return this.hasPurposeSelected ? this.mentionItems : []
  }

  get purposeCards () {
    const descriptions = {
      [this.purposeTypes.ONE_TIME_PAYMENT]: this.$gettext('PURPOSE_ONE_TIME_PAYMENT'),
      [this.purposeTypes.INSTALLMENT]: this.$gettext('PURPOSE_PAYMENT_INSTALLMENT'),
      [this.purposeTypes.REGULAR_INVOICE]: this.$gettext('PURPOSE_REGULAR_INVOICE'),
      [this.purposeTypes.NOTICE]: this.$gettext('PURPOSE_NOTICE'),
      [this.purposeTypes.ADDITIONAL]: this.$gettext('PURPOSE_ADDITIONAL')
    }
    const options = Array.isArray(this.purposeOptions) ? this.purposeOptions : []
    return options.map(option => {
      const id = option.value
      const raw = option.raw || {}
      return {
        id,
        title: option.label || raw.nmDescricao || String(id || ''),
        description: raw.dsDescricao || descriptions[id] || '',
        icon: raw.icon || this.getPurposeIcon(id) || 'description'
      }
    })
  }

  getEditorHtml () {
    const editor = this.$refs.templateEditor
    if (editor && typeof editor.getEditorHtml === 'function') {
      return editor.getEditorHtml()
    }
    return this.formData.content || ''
  }

  getEditorPlainText () {
    const editor = this.$refs.templateEditor
    if (editor && typeof editor.getEditorPlainText === 'function') {
      return editor.getEditorPlainText()
    }
    return (this.formData.content || '').replace(/<[^>]*>/g, '').trim()
  }

  selectPurpose (purposeId) {
    this.formData.messagingPurpose = purposeId
    this.purposeValidationError = false

    this.$nextTick(() => {
      this.$refs.inputTemplatePurpose?.resetValidation()
    })
  }

  onContentUpdate (content) {
    this.formData.content = content

    if (this.hasBodyContent()) {
      this.contentValidationError = false
      this.$nextTick(() => {
        this.$refs.inputTemplateContent?.resetValidation()
      })
    }
  }

  async openCreate () {
    await this.openModal('create')
  }

  async openEdit (id) {
    await this.openModal('edit', id, 'alterar')
  }

  async openDetail (id) {
    await this.openModal('edit', id, 'detalhar')
  }

  async openModal (mode, id = null, action = null) {
    this.mode = mode
    this.currentId = id
    if (mode === 'create') {
      this.resetForm()
      await this.loadCombos()
    }
    if (id && action) {
      await this.loadRecord(id, action)
    }
    this.showModal = true
    this.saveOriginalFormData()
    this.$emit('update:show', true)
  }

  async loadRecord (id, action) {
    try {
      const response = await repository.resolve(`template.${action}`, { id })

      const dadosForm = response?.dadosForm || response?.[0]?.dadosForm || response?.[0] || {}
      const relacionamentos = response?.relacionamentos || response?.[0]?.relacionamentos || {}

      await this.applyFormData(dadosForm)

      if (relacionamentos && Object.keys(relacionamentos).length > 0) {
        this.applyRelacionamentos(relacionamentos)
      } else {
        await this.loadCombos()
      }
    } catch (error) {
      messageBox.error(this.$gettext('ERROR_LOADING_FORM'), 'top-right')
    }
  }

  async applyFormData (form) {
    this.formData.name = form.name || ''
    this.formData.messagingPurpose = this.getIdValue(form.messagingPurpose)
    this.formData.channelType = this.getIdValue(form.channelType)
    this.formData.subject = form.subject || ''
    this.formData.content = form.content || ''
    this.formData.available = form.available !== undefined ? form.available : true

    if (form.templateImages && Array.isArray(form.templateImages)) {
      await this.loadExistingImages(form.templateImages)
    }
  }

  async loadExistingImages (images) {
    try {
      this.removeHeaderImage()
      this.removeFooterImage()
      this.existingImages = []

      for (const img of images) {
        if (!img.nmArquivo || !img.templateImageType) {
          continue
        }

        const imageTypeId = img.templateImageType
        const isHeader = imageTypeId === this.HEADER_IMAGE_TYPE
        const isFooter = imageTypeId === this.FOOTER_IMAGE_TYPE

        if (isHeader || isFooter) {
          try {
            const blob = await this.$jt.repository.downloadFile(
              img.nmArquivo,
              null,
              'MESSAGING_TEMPLATE_IMAGES'
            )
            const blobUrl = URL.createObjectURL(blob)

            this.existingImages.push({
              id: img.id,
              templateImageType: imageTypeId,
              nmArquivo: img.nmArquivo
            })

            if (isHeader) {
              this.headerImagePreview = blobUrl
            } else if (isFooter) {
              this.footerImagePreview = blobUrl
            }
          } catch (error) {
            console.warn(`Erro ao baixar imagem ${img.nmArquivo}:`, error)
          }
        }
      }
    } catch (error) {
      console.error('Erro ao carregar imagens existentes:', error)
    }
  }

  getIdValue (value) {
    if (value && typeof value === 'object') {
      return value.id || value.chCodigo || value.value || null
    }
    return value || null
  }

  async loadCombos () {
    try {
      const [searchForm, variablesForm] = await Promise.all([
        repository.resolve('template.pesquisar'),
        repository.resolveLogic('msgVariableEnum.obterTodos')
      ])

      const searchRel = this.getRelacionamentos(searchForm)

      if (this.purposeOptions.length === 0) {
        this.purposeOptions = this.normalizeOptions(searchRel, ['messagingPurpose'])
      }
      if (this.channelOptions.length === 0) {
        this.channelOptions = this.normalizeOptions(searchRel, ['channelType'])
      }

      this.messageVariables = this.normalizeVariables(variablesForm)

      if (this.purposeOptions.length === 0 || this.channelOptions.length === 0) {
        const form = await repository.resolve('template.gravar')
        const rel = this.getRelacionamentos(form)
        if (this.purposeOptions.length === 0) {
          this.purposeOptions = this.normalizeOptions(rel, ['messagingPurpose'])
        }
        if (this.channelOptions.length === 0) {
          this.channelOptions = this.normalizeOptions(rel, ['channelType'])
        }
      }
    } catch (error) {
      console.error('Erro ao carregar combos:', error)
      this.purposeOptions = []
      this.channelOptions = []
      this.messageVariables = []
    }
  }

  applyRelacionamentos (relacionamentos) {
    if (relacionamentos.messagingPurpose && Array.isArray(relacionamentos.messagingPurpose)) {
      this.purposeOptions = relacionamentos.messagingPurpose.map(item => ({
        label: item.label || item.nmDescricao || String(item.value || ''),
        value: item.value || item.id,
        raw: item
      }))
    }

    if (relacionamentos.channelType && Array.isArray(relacionamentos.channelType)) {
      this.channelOptions = relacionamentos.channelType.map(item => ({
        label: item.label || item.nmDescricao || String(item.value || ''),
        value: item.value || item.id,
        raw: item
      }))
    }
  }

  normalizeOptions (data, preferredKeys = []) {
    const records = this.extractRecords(data, preferredKeys)
    return records
      .map(item => ({
        label: item.nmDescricao || item.label || item.name || String(item.id || ''),
        value: item.id || item.value || item.codigo || item,
        raw: item
      }))
      .filter(item => item.value !== undefined && item.value !== null)
  }

  normalizeVariables (data) {
    const records = this.extractRecords(data)
    const result = records
      .map(category => ({
        variableType: category.variableType,
        nmDescricao: category.nmDescricao,
        variables: Array.isArray(category.variables)
          ? category.variables.map(variable => {
            return {
              technicalKey: variable.technicalKey,
              displayLabel: variable.displayLabel,
              displayTag: variable.displayTag,
              variableType: variable.variableType,
              messagingPurposes: variable.messagingPurposes || [],
              sampleText: variable.sampleText
            }
          })
          : []
      }))
      .filter(category => category.variables && category.variables.length > 0)

    const varType = variableType()
    const getCategoryOrder = (typeId) => {
      if (typeId === varType.FINANCE.key) return 1
      if (String(typeId).startsWith('5047')) return 2
      if (typeId === varType.CONSUMER_UNIT_DATA.key) return 3
      if (typeId === varType.ORGANIZATION.key) return 4
      if (typeId === varType.CONTROL.key) return 5
      return 99
    }

    result.sort((a, b) => getCategoryOrder(a.variableType) - getCategoryOrder(b.variableType))

    return result
  }

  getRelacionamentos (data) {
    if (!data) {
      return {}
    }
    if (Array.isArray(data)) {
      return data[0]?.relacionamentos || data[0] || {}
    }
    return data.relacionamentos || data
  }

  extractRecords (data, preferredKeys = []) {
    if (!data) {
      return []
    }
    if (Array.isArray(data)) {
      if (data[0] && data[0].relacionamentos) {
        const relacionamentos = data[0].relacionamentos
        return this.extractRecords(relacionamentos, preferredKeys)
      }
      if (data[0] && data[0].registros) {
        return data[0].registros
      }
      return data
    }
    if (data.relacionamentos) {
      return this.extractRecords(data.relacionamentos, preferredKeys)
    }
    if (data.reRender) {
      const keys = preferredKeys.filter(key => data.reRender[key])
      const key = keys[0] || Object.keys(data.reRender)[0]
      const relData = data.reRender[key]
      return Array.isArray(relData) ? relData : []
    }
    if (data.registros) {
      return data.registros
    }
    if (preferredKeys.length > 0) {
      const key = preferredKeys.find(item => data[item])
      if (key) {
        const relData = data[key]
        return Array.isArray(relData) ? relData : []
      }
    }
    if (Array.isArray(data)) {
      return data
    }
    return []
  }

  onHeaderClick () {
    this.onImageClick('header')
  }

  onFooterClick () {
    this.onImageClick('footer')
  }

  onImageClick (target) {
    this.$refs[`${target}Input`]?.click()
  }

  onHeaderFileChange (event) {
    this.onImageFileChange(event, 'header')
  }

  onFooterFileChange (event) {
    this.onImageFileChange(event, 'footer')
  }

  onImageFileChange (event, target) {
    const file = event.target.files[0]
    if (file) this.processImage(file, target)
  }

  onDropHeader (event) {
    this.onDropImage(event, 'header')
  }

  onDropFooter (event) {
    this.onDropImage(event, 'footer')
  }

  onDropImage (event, target) {
    const file = event.dataTransfer.files[0]
    if (file?.type.startsWith('image/')) {
      this.processImage(file, target)
    }
  }

  processImage (file, target) {
    const previewKey = `${target}ImagePreview`
    const fileKey = `${target}ImageFile`

    this.revokePreviewUrl(this[previewKey])
    this[previewKey] = URL.createObjectURL(file)
    this[fileKey] = file
  }

  revokePreviewUrl (url) {
    if (url) URL.revokeObjectURL(url)
  }

  removeHeaderImage () {
    this.removeImage('header')
  }

  removeFooterImage () {
    this.removeImage('footer')
  }

  removeImage (target) {
    const previewKey = `${target}ImagePreview`
    const fileKey = `${target}ImageFile`
    const inputRef = `${target}Input`

    if (this[previewKey]) {
      this.revokePreviewUrl(this[previewKey])
      this[previewKey] = null
    }
    this[fileKey] = null
    if (this.$refs[inputRef]) {
      this.$refs[inputRef].value = ''
    }
  }

  insertVariablePlaceholder (variable) {
    if (!this.hasPurposeSelected) {
      return
    }

    const editor = this.$refs.templateEditor
    if (editor && typeof editor.insertVariablePlaceholder === 'function') {
      editor.insertVariablePlaceholder(variable)
    }
  }

  onSubjectUpdate (content) {
    this.formData.subject = content
    if (this.hasSubjectContent()) {
      this.subjectValidationError = false
    }
  }

  applySmsFormattingRules () {
    if (!this.isSmsChannel) {
      return
    }

    const editor = this.$refs.templateEditor
    if (editor && typeof editor.clearFormatting === 'function') {
      editor.clearFormatting()
    }

    const cleanedHtml = this.getEditorHtml()
    if (cleanedHtml !== this.formData.content) {
      this.formData.content = cleanedHtml
    }
  }

  getPreviewContent () {
    let html = this.formData.content || ''
    html = html.replace(/onclick=["'][^"']*["']/g, '')
    return html
  }

  getVariableLabelById (technicalKey) {
    if (!technicalKey || !this.messageVariables) {
      return null
    }

    for (const category of this.messageVariables) {
      if (!Array.isArray(category.variables)) {
        continue
      }
      const variable = category.variables.find(v => v.technicalKey === technicalKey)
      if (variable) {
        return variable.displayLabel || variable.displayTag || null
      }
    }

    return null
  }

  getProcessedBodyContent () {
    return this.getEditorHtml().trim()
  }

  getProcessedSubjectContent () {
    return String(this.formData.subject || '').trim()
  }

  hasSubjectContent () {
    const serializedSubject = this.getProcessedSubjectContent()
    if (!serializedSubject) {
      return false
    }

    if (/\{\{\$[A-Za-z0-9_]+\}\}/.test(serializedSubject)) {
      return true
    }

    const normalizedText = serializedSubject
      .replace(/&nbsp;|&#160;/gi, ' ')
      .replace(/<br\s*\/?>/gi, ' ')
      .replace(/<\/p>/gi, ' ')
      .replace(/<[^>]*>/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()

    return normalizedText.length > 0
  }

  hasBodyContent () {
    const plainText = String(this.getEditorPlainText() || '')
      .replace(/\u00A0/g, ' ')
      .trim()

    if (plainText.length > 0) {
      return true
    }

    const serializedContent = String(this.getProcessedBodyContent() || '')
    if (!serializedContent) {
      return false
    }

    if (/\{\{\$[A-Za-z0-9_]+\}\}/.test(serializedContent)) {
      return true
    }

    const normalizedText = serializedContent
      .replace(/&nbsp;|&#160;/gi, ' ')
      .replace(/<br\s*\/?>/gi, ' ')
      .replace(/<\/p>/gi, ' ')
      .replace(/<[^>]*>/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()

    return normalizedText.length > 0
  }

  async onCloseButtonClick () {
    await this.onCancel()
  }

  async onDialogEscapeKey () {
    await this.onCancel()
  }

  async onCancel () {
    const changedFields = this.getChangedFields()
    if (changedFields.length > 0) {
      const confirmed = await this.showDiscardChangesDialog(changedFields)
      if (!confirmed) {
        return
      }
    }
    this.showModal = false
    this.resetForm()
  }

  async onSave () {
    if (!this.formData.name) {
      this.$refs.inputTemplateName?.validate()
      messageBox.warn(this.$gettext('MSG_TEMPLATE_NAME_REQUIRED'), 'top-right')
      return
    }

    if (!this.formData.channelType) {
      this.$refs.inputTemplateChannel?.validate()
      messageBox.warn(this.$gettext('MSG_TEMPLATE_CHANNEL_REQUIRED'), 'top-right')
      return
    }

    if (this.formData.messagingPurpose === null || this.formData.messagingPurpose === undefined || this.formData.messagingPurpose === '') {
      this.purposeValidationError = true
      this.$refs.inputTemplatePurpose?.validate()
      messageBox.warn(this.$gettext('MSG_TEMPLATE_PURPOSE_REQUIRED'), 'top-right')
      return
    }

    if (!this.hasSubjectContent()) {
      this.subjectValidationError = true
      messageBox.warn(this.$gettext('MSG_SUBJECT_REQUIRED'), 'top-right')
      return
    }

    if (!this.hasBodyContent()) {
      this.contentValidationError = true
      this.$refs.inputTemplateContent?.validate()
      messageBox.warn(this.$gettext('MSG_TEMPLATE_BODY_REQUIRED'), 'top-right')
      return
    }

    const changedFields = this.getChangedFields()
    if (changedFields.length > 0) {
      const confirmed = await this.showConfirmSaveDialog(changedFields)
      if (!confirmed) {
        return
      }
    } else {
      messageBox.info(this.$gettext('MSG_TEMPLATE_NO_CHANGES'), 'top-right')
      return
    }

    try {
      const payload = {
        name: this.formData.name,
        messagingPurpose: this.formData.messagingPurpose,
        channelType: this.formData.channelType,
        subject: this.getProcessedSubjectContent(),
        content: this.getProcessedBodyContent(),
        available: this.formData.available
      }

      const images = []

      // Apenas enviar imagens que foram realmente modificadas ou removidas
      // Se nenhuma mudança de imagem, não incluir templateImages no payload

      // 1. Adicionar header (nova, não alterada, ou nenhuma)
      if (this.headerImageFile) {
        // Nova/Modificada
        const headerFileName = await repository.updateFile(
          'templateImage.composicao',
          'nmArquivo',
          this.headerImageFile
        )
        images.push({
          id: null,
          templateImageType: this.HEADER_IMAGE_TYPE,
          nmArquivo: headerFileName,
          flAlterado: true
        })
      } else if (this.headerImagePreview && this.existingImages?.some(img => img.templateImageType === this.HEADER_IMAGE_TYPE)) {
        // Não alterada - enviar como está
        const existingHeader = this.existingImages.find(img => img.templateImageType === this.HEADER_IMAGE_TYPE)
        images.push({
          id: existingHeader?.id,
          templateImageType: this.HEADER_IMAGE_TYPE,
          nmArquivo: existingHeader?.nmArquivo,
          flAlterado: false
        })
      }

      // 2. Adicionar footer (nova, não alterada, ou nenhuma)
      if (this.footerImageFile) {
        // Nova/Modificada
        const footerFileName = await repository.updateFile(
          'templateImage.composicao',
          'nmArquivo',
          this.footerImageFile
        )
        images.push({
          id: null,
          templateImageType: this.FOOTER_IMAGE_TYPE,
          nmArquivo: footerFileName,
          flAlterado: true
        })
      } else if (this.footerImagePreview && this.existingImages?.some(img => img.templateImageType === this.FOOTER_IMAGE_TYPE)) {
        // Não alterada - enviar como está
        const existingFooter = this.existingImages.find(img => img.templateImageType === this.FOOTER_IMAGE_TYPE)
        images.push({
          id: existingFooter?.id,
          templateImageType: this.FOOTER_IMAGE_TYPE,
          nmArquivo: existingFooter?.nmArquivo,
          flAlterado: false
        })
      }

      // 3. Marcar imagens para remoção
      const headerWasRemoved = !this.headerImageFile && !this.headerImagePreview && this.existingImages?.some(img => img.templateImageType === this.HEADER_IMAGE_TYPE)
      const footerWasRemoved = !this.footerImageFile && !this.footerImagePreview && this.existingImages?.some(img => img.templateImageType === this.FOOTER_IMAGE_TYPE)

      if (headerWasRemoved) {
        const existingHeader = this.existingImages.find(img => img.templateImageType === this.HEADER_IMAGE_TYPE)
        images.push({
          id: existingHeader?.id,
          flDeletado: true
        })
      }
      if (footerWasRemoved) {
        const existingFooter = this.existingImages.find(img => img.templateImageType === this.FOOTER_IMAGE_TYPE)
        images.push({
          id: existingFooter?.id,
          flDeletado: true
        })
      }

      if (images.length > 0) {
        payload.templateImages = images
      }

      if (this.mode === 'edit' && this.currentId) {
        const updatePayload = {
          id: this.currentId,
          ...payload
        }
        await repository.update('template.alterar', updatePayload)
      } else {
        await repository.create('template.gravar', payload)
      }

      this.$emit('template-saved', this.formData)
      this.showModal = false
      this.resetForm()
    } catch (error) {
      console.error('Erro ao salvar template:', error)
    }
  }

  closeSubjectMentionMenu () {
    const subjectEditor = this.$refs.subjectEditor
    const editorInstance = subjectEditor?.editor
    if (editorInstance?.commands?.blur) {
      editorInstance.commands.blur()
    }
  }

  resetForm () {
    this.formData = {
      name: '',
      messagingPurpose: null,
      channelType: null,
      subject: '',
      content: '',
      available: true
    }

    this.mode = 'create'
    this.currentId = null
    this.existingImages = []
    this.purposeValidationError = false
    this.subjectValidationError = false
    this.contentValidationError = false
    this.closeSubjectMentionMenu()
    this.removeHeaderImage()
    this.removeFooterImage()
  }

  saveOriginalFormData () {
    this.originalFormData = {
      name: this.formData.name,
      messagingPurpose: this.formData.messagingPurpose,
      channelType: this.formData.channelType,
      subject: this.formData.subject,
      content: this.formData.content,
      available: this.formData.available
    }
    this.originalHeaderImagePreview = this.headerImagePreview
    this.originalFooterImagePreview = this.footerImagePreview
  }

  getDisplayValue (fieldName, value) {
    if (fieldName === 'messagingPurpose' && value) {
      const option = this.purposeOptions.find(p => p.value === value)
      return option ? option.label : String(value)
    }
    if (fieldName === 'channelType' && value) {
      const option = this.channelOptions.find(c => c.value === value)
      return option ? option.label : String(value)
    }
    if (fieldName === 'available') {
      return value ? this.$gettext('ACTIVE') : this.$gettext('INACTIVE')
    }
    return value
  }

  getChangedFields () {
    const changes = []
    const fieldLabels = {
      name: this.$gettext('TEMPLATE_NAME'),
      messagingPurpose: this.$gettext('MSG_TEMPLATE_PURPOSE_TYPE_LABEL'),
      channelType: this.$gettext('MSG_TEMPLATE_CHANNEL_TYPE_LABEL'),
      subject: this.$gettext('SUBJECT'),
      content: this.$gettext('MSG_TEMPLATE_CONTENT_LABEL'),
      available: this.$gettext('MSG_TEMPLATE_STATUS_LABEL')
    }

    for (const [key, label] of Object.entries(fieldLabels)) {
      if (this.formData[key] !== this.originalFormData[key]) {
        changes.push(label)
      }
    }

    if (this.headerImagePreview !== this.originalHeaderImagePreview) {
      changes.push(this.$gettext('MSG_TEMPLATE_HEADER_IMAGE_LABEL'))
    }

    if (this.footerImagePreview !== this.originalFooterImagePreview) {
      changes.push(this.$gettext('MSG_TEMPLATE_FOOTER_IMAGE_LABEL'))
    }

    return changes
  }

  showConfirmSaveDialog (changedFields) {
    return new Promise((resolve) => {
      const itemsList = changedFields
        .map(field => `
          <div style="display: flex; align-items: flex-start; gap: 8px;">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#d18e4b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-top: 2px; flex-shrink: 0;">
              <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"></path>
              <path d="M12 9v4"></path>
              <path d="M12 17h.01"></path>
            </svg>
            <span style="font-size: 12px; color: #52525b;">${this.$gettext('MSG_TEMPLATE_FIELD_CHANGED')}: ${field}</span>
          </div>
        `)
        .join('')

      const templateName = this.formData.name || 'Template'
      const confirmUpdate = this.$gettext('MSG_TEMPLATE_CONFIRM_UPDATE')
      const messageHTML = `
        <div style="text-align: left;">
          <div style="margin-bottom: 16px; line-height: 1.5; color: #333;">
            ${confirmUpdate} "${templateName}"?
          </div>
          <div style="background-color: #f8fafc; border: 1px solid #e8ecf0; border-radius: 6px; padding: 12px; space: 6px;">
            ${itemsList}
          </div>
        </div>
      `

      this.$q.dialog({
        title: this.$gettext('MSG_TEMPLATE_SAVE_TITLE'),
        message: messageHTML,
        html: true,
        ok: {
          push: true,
          label: this.$gettext('SAVE'),
          color: 'primary'
        },
        cancel: {
          push: true,
          label: this.$gettext('CANCEL'),
          color: 'grey-4',
          textColor: 'grey-9'
        }
      }).onOk(() => {
        resolve(true)
      }).onCancel(() => {
        resolve(false)
      })
    })
  }

  showDiscardChangesDialog (changedFields) {
    return new Promise((resolve) => {
      const itemsList = changedFields
        .map(field => `
          <div style="display: flex; align-items: flex-start; gap: 8px;">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#d18e4b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-top: 2px; flex-shrink: 0;">
              <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"></path>
              <path d="M12 9v4"></path>
              <path d="M12 17h.01"></path>
            </svg>
            <span style="font-size: 12px; color: #52525b;">${this.$gettext('MSG_TEMPLATE_WILL_DISCARD')}: ${field}</span>
          </div>
        `)
        .join('')

      const discardMsg = this.$gettext('MSG_TEMPLATE_DISCARD_UNSAVED_MSG')
      const messageHTML = `
        <div style="text-align: left;">
          <div style="margin-bottom: 16px; line-height: 1.5; color: #333;">
            ${discardMsg}
          </div>
          <div style="background-color: #f8fafc; border: 1px solid #e8ecf0; border-radius: 6px; padding: 12px; space: 6px;">
            ${itemsList}
          </div>
        </div>
      `

      this.$q.dialog({
        title: this.$gettext('MSG_TEMPLATE_DISCARD_TITLE'),
        message: messageHTML,
        html: true,
        ok: {
          push: true,
          label: this.$gettext('MSG_TEMPLATE_DISCARD_BTN'),
          color: 'primary'
        },
        cancel: {
          push: true,
          label: this.$gettext('MSG_TEMPLATE_KEEP_EDITING_BTN'),
          color: 'grey-4',
          textColor: 'grey-9'
        }
      }).onOk(() => {
        resolve(true)
      }).onCancel(() => {
        resolve(false)
      })
    })
  }

  showConfirmDialog (title, message) {
    return new Promise((resolve) => {
      this.$q.dialog({
        title: title,
        message: message,
        html: true,
        ok: {
          push: true,
          label: this.$gettext('YES_CAPITALIZE'),
          color: 'primary'
        },
        cancel: {
          push: true,
          label: this.$gettext('NO_CAPITALIZE'),
          color: 'grey-7'
        }
      }).onOk(() => {
        resolve(true)
      }).onCancel(() => {
        resolve(false)
      })
    })
  }

  onHide () {
    this.$emit('update:show', false)
    this.resetForm()
  }

  @Watch('show')
  onShowChange (newVal) {
    this.showModal = newVal
  }

  @Watch('showModal')
  onShowModalChange (newVal) {
    if (!newVal) {
      this.$emit('update:show', false)
      return
    }
    if (
      this.purposeOptions.length === 0 ||
      this.channelOptions.length === 0
    ) {
      this.loadCombos()
    }
  }

  @Watch('formData.channelType')
  onChannelTypeChange () {
    this.$nextTick(() => {
      this.applySmsFormattingRules()
    })
  }
}

export default TemplateModal
</script>

<style lang="stylus" scoped>
.modal-large
  width: 85vw
  max-width: 85vw

.modal-header-fixed
  position: sticky
  top: 0
  z-index: 2000

.modal-footer-fixed
  z-index: 2000

.template-page
  padding: 16px 16px 16px 16px
  overflow: hidden

  &::v-deep .q-page
    padding-top: 0 !important
    padding-bottom: 0 !important
    overflow: hidden

.template-container
  overflow: hidden

.template-col-left
  height: calc(85vh - 70px)
  overflow-y: auto
  overflow-x: hidden
  padding-right: 8px

.template-col-right
  height: calc(90vh - 70px)
  overflow-y: auto
  overflow-x: hidden

  &::v-deep .q-card,
  &::v-deep .q-card__section,
  &::v-deep .q-card-section
    overflow: visible !important

.section-body
  padding-top: 16px

.template-footer
  background-color: #ffffff
  border-top: 1px solid rgba(0, 0, 0, 0.12)

.variables-by-category
  display: flex
  flex-direction: column
  gap: 8px

.variable-category
  .category-title
    display: flex
    align-items: center
    gap: 6px
    font-weight: 600
    color: #666
    font-size: 0.875rem
    letter-spacing: 0.5px

.category-dot
  display: inline-block
  width: 6px
  height: 6px
  border-radius: 999px
  background-color: #666

.category-dot.chip-yellow
  background-color: #f57f17

.category-dot.chip-green
  background-color: #2e7d32

.category-dot.chip-purple
  background-color: #6a1b9a

.category-dot.chip-blue
  background-color: #01579b

.category-dot.chip-orange
  background-color: #e65100

.variables-container
  display: flex
  flex-wrap: wrap
  gap: 4px

.subject-editor-wrapper
  border: 1px solid transparent
  border-radius: 4px
  transition: border-color 0.2s ease, box-shadow 0.2s ease

.subject-editor-wrapper--error
  border: 2px solid #c10015 !important
  box-shadow: inset 0 0 0 1px #c10015

  ::v-deep .subject-editor-container
    border-color: transparent !important
    box-shadow: none !important

.purpose-grid
  display: grid
  grid-template-columns: repeat(3, minmax(0, 1fr))
  overflow: hidden
  border: 1px solid transparent
  border-radius: 4px
  transition: border-color 0.2s ease, box-shadow 0.2s ease

.purpose-grid--error
  border: 2px solid #c10015 !important
  box-shadow: inset 0 0 0 1px #c10015

.purpose-item
  position: relative
  box-sizing: border-box
  padding: 16px
  text-align: center
  display: flex
  flex-direction: column
  align-items: center
  border-right: 1px solid #e0e0e0
  border-bottom: 1px solid #e0e0e0
  cursor: pointer
  transition: background-color 0.2s ease, border-color 0.2s ease

  &:hover
    background-color: #f5f9ff

  &:nth-child(3n)
    border-right: none

  &:nth-last-child(-n+3)
    border-bottom: none

.purpose-item.is-selected
  background-color: #e8f0fe
  box-shadow: inset 0 0 0 1px #1e88e5
  border-radius: 8px
  .purpose-title
    color: #1e88e5
  .purpose-icon
    color: #1e88e5

.purpose-check
  position: absolute
  top: 8px
  right: 8px
  color: #1e88e5

.purpose-icon
  margin-bottom: 8px
  display: flex
  justify-content: center
  align-items: center

.purpose-title
  font-weight: 600
  color: #1f1f1f
  margin-bottom: 4px

.purpose-desc
  color: #6b6b6b
  font-size: 12px
  line-height: 1.4
  max-width: 100%
  word-break: break-word

@media (max-width: 1024px)
  .purpose-grid
    grid-template-columns: repeat(2, minmax(0, 1fr))

  .purpose-item
    &:nth-child(3n)
      border-right: 1px solid #e0e0e0

    &:nth-child(2n)
      border-right: none

    &:nth-last-child(-n+2)
      border-bottom: none

@media (max-width: 600px)
  .purpose-grid
    grid-template-columns: 1fr

  .purpose-item
    border-right: none

    &:nth-last-child(-n+1)
      border-bottom: none

.variable-chip
  display: inline-flex
  align-items: center
  padding: 2px 6px
  border-radius: 16px
  background-color: #e0f7fa
  color: #006064
  font-size: 12px
  cursor: pointer
  transition: all 0.2s ease

  &:hover
    opacity: 0.8

.hidden-content-validation
  height: 0
  overflow: hidden

.template-body-wrapper
  border: 1px solid transparent
  border-radius: 4px
  transition: border-color 0.2s ease, box-shadow 0.2s ease

.template-body-wrapper--error
  border: 2px solid #c10015 !important
  box-shadow: inset 0 0 0 1px #c10015
</style>

<style>
::v-deep .editor-variable-chip {
  display: inline-flex;
  align-items: center;
  padding: 2px 6px;
  border-radius: 16px;
  background-color: #bbdefb;
  color: #01579b;
  font-weight: 400;
  font-size: 12px;
  cursor: default;
  vertical-align: middle;
  white-space: nowrap;
  line-height: 1.2;
}

/* Cores dos chips por tipo de variável */
::v-deep .editor-variable-chip.chip-yellow {
  background-color: #fff9c4;
  color: #f57f17;
}

::v-deep .editor-variable-chip.chip-green {
  background-color: #c8e6c9;
  color: #2e7d32;
}

::v-deep .editor-variable-chip.chip-purple {
  background-color: #e1bee7;
  color: #6a1b9a;
}

::v-deep .editor-variable-chip.chip-blue {
  background-color: #bbdefb;
  color: #01579b;
}

::v-deep .editor-variable-chip.chip-orange {
  background-color: #ffe0b2;
  color: #e65100;
}
</style>
